import React from 'react';
import { WifiOff, Eye } from 'lucide-react';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

/**
 * Banner that shows when device is offline
 * Displays at the top of the screen
 */
const OfflineBanner = () => {
  const { isOffline } = useNetworkStatus();

  if (!isOffline) return null;

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[99999] bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2 shadow-lg"
      data-testid="offline-banner"
    >
      <div className="flex items-center justify-center gap-2 text-sm font-medium">
        <WifiOff className="w-4 h-4 animate-pulse" />
        <span>You&apos;re offline</span>
        <span className="hidden sm:inline">—</span>
        <span className="hidden sm:flex items-center gap-1">
          <Eye className="w-3 h-3" />
          View-only mode
        </span>
      </div>
    </div>
  );
};

export default OfflineBanner;
